// extracted by mini-css-extract-plugin
export default {"form":"styles_form__8Yh0I","mainContainer":"styles_mainContainer__jl9gk","leftContainer":"styles_leftContainer__nbvIN","rightContainer":"styles_rightContainer__EMoYg"};